<script setup lang="ts">
import {onMounted, ref} from "vue";
import {Car, Loading, Ok, Result, Upcoming, UpcomingData} from "../model/model";
import CarService from '../services/CarService';
import {emitter} from "../main";
import {Message, MessageType} from "../components/global/MessageView.vue";
import router from "../router";
import UpcomingListing from "../components/reactive/UpcomingListing.vue";

const carService = new CarService();

const loadedNews = ref<Result<String, Array<UpcomingData>>>(new Loading(""))

function fetch() {
  carService.carsWithUpcoming()
      .then(cars => loadedNews.value = new Ok(cars))
      .catch(() => emitter.emit("log", new Message("car.load.fail", MessageType.Error)))
}

onMounted(() => fetch())

function carSelect(car: Car) {
  router.push({ name: "viewCar", params: {carId: car.id} });
}

function hideUpcoming(upcoming: Upcoming) {
  carService.hideUpcoming(upcoming.id)
      .then(() => {
        let loaded = loadedNews.value as Ok<Array<UpcomingData>>
        if (loaded) {
          let index = loaded.data.findIndex((u: UpcomingData) => u.id == upcoming.id)
          if (index >= 0) {
            loaded.map((news) => news.splice(index, 1))
          }
        }
      })
      .catch(() => emitter.emit("log", new Message("message.genericError", MessageType.Error)))
}
</script>

<template>
  <main>
    <div id="title-container">
      <h1 id="title-label">{{ $t("global.upcoming") }}</h1>
    </div>
    <UpcomingListing :news="loadedNews" @car-select="carSelect" @hide-upcoming="hideUpcoming" />
  </main>
</template>

<style scoped>
#title-container {
  margin-bottom: 1rem;
}

#title-container>div {
  display: inline-block;
}

h1 {
  display: inline-block;
  margin: 0.5rem;
}

#title-label {
  font-weight: bold;
  cursor: pointer;
}
</style>
